export default __webpack_public_path__ + "paddle_city_hover26e340.svg";